import { StoreModelCollection } from "../model.collection.abstraction";
import { StoreModelNames } from "../../dali/type/dali.type";
import { signal } from "@angular/core";
import { ScenarioStoreModel } from "../../../models/store/scenario.store.model";
import { ScenarioView } from "@bitwarden/web-vault/app/models/view/scenario/scenario.view";
import { toObservable } from "@angular/core/rxjs-interop";

export class ScenarioStoreCollection extends StoreModelCollection {
  readonly type: StoreModelNames = "ScenarioStoreModel";
  protected models: Map<string, ScenarioStoreModel> = new Map<string, ScenarioStoreModel>();

  private _scenarioViews = signal<ScenarioView[]>([]);
  readonly scenarioView = this._scenarioViews.asReadonly();
  scenarioView$ = toObservable(this.scenarioView);

  triggerChanges(): void {
    const views: ScenarioView[] = [];
    this.models.forEach((model) => {
      views.push(this.deepFreeze(new ScenarioView(model)));
    });
    this._scenarioViews.set(views);
  }
  clear(): void {
    this.models.clear();
    this._scenarioViews.set([]);
  }

  populateWithSystemDefaults(defaults: ScenarioView[]) {
    let views: ScenarioView[] = [];
    this.models.forEach((model) => {
      views.push(this.deepFreeze(new ScenarioView(model)));
    });

    views = [...views, ...defaults];
    this._scenarioViews.set(views);
  }
}
